import axios from 'axios';
import { router } from '@inertiajs/vue3';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

const authRedirectStatuses = new Set([401, 419]);
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error?.response?.status;
        if (authRedirectStatuses.has(status)) {
            if (window.location.pathname !== '/login') {
                window.location.assign('/login');
            }

            return Promise.resolve();
        }

        // Pull the shared flag so the layout shows the reconnect notice.
        if (status === 409 && error.response.data?.code === 'teamleader_token_invalid') {
            router.reload({ only: ['teamleaderDisconnected'] });
        }

        return Promise.reject(error);
    }
);
